import { render, staticRenderFns } from "./TakeCourseEmpty.vue?vue&type=template&id=2dbb9232&"
import script from "./TakeCourseEmpty.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TakeCourseEmpty.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports